<input
  class="branding-input"
  [style.background]="color"
  [colorPicker]="color"
  (colorPickerChange)="onColorPickerChange($event)"
  (colorPickerClose)="closed.emit($event)"
  [cpPosition]="position"
  [readonly]="true"
  [attr.data-testid]="testId"
/>
